import { SortControl } from "components/controls";
import { ToggleButton } from "components/buttons";

import "components/feed/FeedControl.scss";

export const FeedControl = (props: {
  order: string;
  verified: boolean;
  changeOrder: (value: string) => void;
  changeVerified: (value: boolean) => void;
  isWithLatest?: boolean;
}) => {
  const onVerifiedToggle = (value: boolean) => {
    props.changeVerified && props.changeVerified(value);
  };

  const SORT_OPTIONS = {
    trending: "Trending",
    top: "Top",
    ...(props.isWithLatest ? { recent: "Latest" } : { new: "Latest" }),
    old: "Oldest",
  };

  return (
    <div className="feedControl">
      <SortControl
        order={props.order}
        options={SORT_OPTIONS}
        onChange={props.changeOrder}
      />
      <div className="verified">
        <ToggleButton
          className="small right"
          label="Verified only"
          checked={!!props.verified}
          onChange={onVerifiedToggle}
        />
      </div>
    </div>
  );
};
